<template>
    <v-card>
        <v-form ref="billingItemFileForm" v-model="isValid">
            <v-card-text>
                <v-container class="pb-0" fluid>
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-select
                                :disabled="true/*isLoading || billingItemFile.isVerified*/"
                                :items="accountFileTypes"
                                :rules="[(v) => v !== undefined || 'required']"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="File Type"
                                v-model="billingItemFile.accountFileType"
                            ></v-select>
                        </v-col>

                        <!--<v-col cols="12">
                            <v-switch
                                :disabled="isLoading || isServiceProviderUser"
                                class="mb-0"
                                label="Verified"
                                v-model="billingItemFile.isVerified"
                            ></v-switch>
                        </v-col>

                        <v-col cols="12">
                            <v-switch
                                :disabled="isLoading || isServiceProviderUser"
                                class="mb-0"
                                label="Valid Indefinitely"
                                v-model="indefinitelyValid"
                            ></v-switch>
                        </v-col>

                        <v-col cols="12" v-show="!indefinitelyValid">
                            <v-menu
                                :close-on-content-click="false"
                                :disabled="isLoading || isServiceProviderUser"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="validUntilDateMenu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                !!indefinitelyValid ||
                                                'required',
                                        ]"
                                        label="Valid Until"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-model="billingItemFile.validUntil"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="validUntilDateMenu = false"
                                    v-model="billingItemFile.validUntil"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>-->

                        <v-col cols="12" v-show="!billingItemFile.id">
                            <v-file-input
                                :disabled="isLoading"
                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                label="File"
                                placeholder="Select a file"
                                v-model="newFile"
                            ></v-file-input>
                            <div style="color: red" v-show="!fileAvailable">
                                you have to select a file to add a file
                            </div>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="canDelete && billingItemFile.id > 0"
                            >Delete</v-btn
                        >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Close</v-btn
                        >
                        <v-btn
                            v-show="!(billingItemFile.id > 0)"
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >{{ billingItemFile.id > 0 ? "Update" : "Add" }}</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import BillingItemFile from "../../models/BillingItemFile.model";
import dateToString from "../../helpers/dateToString";
import RoleType from "../../constants/RoleType.constant";
export default {
    props: {
        billingItemFileIn: Object,
        canDelete: Boolean,
    },
    components: {},
    computed: {
        fileAvailable: function () {
            if (this.billingItemFile.fileId > 0) return true;

            return !!this.newFile;
        },
        isServiceProviderUser: function () {
            return (
                this.userRoles.findIndex(
                    (x) => x == RoleType.ServiceProviderUser
                ) > -1
            );
        },
    },
    created: async function () {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );
        this.accountFileTypes = await this.$store.dispatch(
            "accounts/getFileTypes"
        );
        this.billingItemFile = this.loadEntity(this.billingItemFileIn);
    },
    data() {
        return {
            billingItemFile: new BillingItemFile(),
            userRoles: [],
            accountFileTypes: [],
            newFile: null,
            validUntilDateMenu: false,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            indefinitelyValid: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
        };
    },
    methods: {
        loadEntity(loadIdentity) {
            var toLoad = new BillingItemFile().set(loadIdentity);

            toLoad.validUntil = dateToString(
                toLoad.validUntil ? new Date(toLoad.validUntil) : null
            );

            if (toLoad.validUntil == null) this.indefinitelyValid = true;

            return toLoad;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedBillingItemFile) {
            this.$emit("saved", savedBillingItemFile);
        },
        emitDeletedEntity(deletedBillingItemFile) {
            this.$emit("deleted", deletedBillingItemFile);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.billingItemFileForm.validate();
            return this.isValid && this.fileAvailable;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var entityOut = new BillingItemFile().set(this.billingItemFile);
                if (this.indefinitelyValid) entityOut.validUntil = null;

                (this.billingItemFile.id == 0
                    ? this.createEntity(entityOut)
                    : this.updateEntity(entityOut)
                )
                    .then(
                        (response) => {
                            this.notify(
                                "File successfully saved.",
                                "success"
                            );
                            if (this.billingItemFile.id == 0) {
                                this.billingItemFile.id = response.id;
                            }
                            this.emitSavedEntity(response);
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        createEntity(entityOut) {
            var formdata = new FormData();
            formdata.append("NewFile", this.newFile);
            formdata.append("Model", JSON.stringify(entityOut));

            const parameters = {
                formdata: formdata,
                billingItemId: entityOut.billingItemId,
            };

            return this.$store.dispatch("billingitems/createFile", parameters);
        },
        updateEntity(entityOut) {
            return this.$store.dispatch("billingitems/updateFile", entityOut);
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this file?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("billingitems/deleteFile", {
                        billingItemId: this.billingItemFile.billingItemId,
                        billingItemFileId: this.billingItemFile.id,
                    })
                    .then(
                        () => {
                            this.notify(
                                "File successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.billingItemFile);
                            this.closeForm();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
    },
};
</script>

<style lang="stylus" scoped></style>